// Translation: External > Provider button (German)
export default Object.freeze({
	continueWithProvider: '',
	signUpWithProvider: '',
	signInWithProvider: ''
})
